import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {LocalStorageSettingsService} from '../../../shared/services/local-storage-settings.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {constants} from 'src/app/shared/common/contants';
import {EtlService} from '../../vault-data-migration-etl/etl.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';

export interface FormData {
  data: any;
  action: any;

}

@Component({
    selector: 'app-splite-and-generate-qtl-report',
    templateUrl: './splite-and-generate-qtl-report-popup.component.html',
    styleUrls: ['./splite-and-generate-qtl-report-popup.component.scss'],
    standalone: false
})
export class SpliteAndGenerateQtlReportPopupComponent implements OnInit {

  statevaluechange = {
    'fileName': '',
    'fileData': '',
    'migrationId': 0,
    'action': 0,
    quantitativeFileName:'',
    quantitativeFileData:''
  };
  FormValidCsv: UntypedFormGroup;
  backgroundColorScreen = '';
  buttonColor = '';
  imagephoto;
  imagephotoshow: any = false;
  titleText = '';
  isFileUploded=false
  isQuantitativeFileUploaded= false;
  filetype= '';


  constructor(private localStorageSettings: LocalStorageSettingsService,
              private snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) public data: FormData,
              private dialogref: MatDialogRef<SpliteAndGenerateQtlReportPopupComponent>,
              private constants: constants,
              private service: EtlService,
              private spinner: NgxUiLoaderService
  ) {
  }

  ngOnInit() {
    this.backgroundColorScreen = this.localStorageSettings.getSettings('ColorD');
    this.buttonColor = this.localStorageSettings.getSettings('ColorA');
    this.formvalidationCsv();
    console.log(this.data.data.migrationId);
    this.statevaluechange.migrationId = this.data.data.migrationId;
    this.statevaluechange.action = this.data.action;
    console.log(this.statevaluechange.action);
    if (this.statevaluechange.action == 1) {
      this.titleText = 'Generate Validation Summary Report';
    } else {
      this.titleText = 'Generate Validation Split Report'
    }
  }

  // upload file for csv
  imagePhotofunction($event, filecheck,reporttype): void {
    //this.readThisimage($event.target, filecheck);

    this.readThisimageState($event.target, filecheck,reporttype);
  }

  // to encode the selected photozipfileextraction

  formvalidationCsv() {
  
    this.FormValidCsv = new UntypedFormGroup({
      imageName: new UntypedFormControl(''),
      imageupload: new UntypedFormControl(''),
      quantitativeImageupload:new UntypedFormControl(''),
      quantitativeImageName: new UntypedFormControl(''),
    });
    
  }

  readThisimageState(inputValue: any, filecheck: any,reportType): void {
    console.log(reportType);
    let ischeckfile = false;
    var file: File = inputValue.files[0];
    var FileS: File = inputValue.files[0];
    console.log(file.type);
    if (file.type === 'text/csv' || file.type === 'application/vnd.ms-excel') {

      console.log(file.size);
      console.log(file.size / 1000);
      var size = file.size / 1000;
      var fileName = FileS.name;
      //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

      var photo: FileReader = new FileReader();
      photo.onloadend = e => {
        var img = photo.result;
        console.log(photo.result);
        var photobase64result = photo.result.toString().split(',', 2)[1];

        // this is to check the file is empty or not
        if (photobase64result == null) {
          console.log('photobase64result is null');
        } else {
          if (reportType=== 'quantitative')
          {

            this.imagephoto = photo.result.toString();
            this.imagephotoshow = true;
            this.statevaluechange.quantitativeFileData = photobase64result;
            this.statevaluechange.quantitativeFileName = fileName;
            this.statevaluechange.fileData = null;
            this.statevaluechange.fileName = null;
            console.log(this.statevaluechange);
            this.FormValidCsv.controls.quantitativeImageName.setValue(fileName);
          }else{
            this.imagephoto = photo.result.toString();
            this.imagephotoshow = true;
            this.statevaluechange.fileData = photobase64result;
            this.statevaluechange.fileName = fileName;
            this.statevaluechange.quantitativeFileData = null;
            this.statevaluechange.quantitativeFileName = null;
            console.log(this.statevaluechange);
            this.FormValidCsv.controls.imageName.setValue(fileName);
          }
          this.filetype= reportType


          //  this.getActionItems();
          // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;
        }
      };
      photo.readAsDataURL(file);
    } else {
      this.snackBar.open(file.name + ' is a invalid file type ', 'OK', {
        duration: 5000,
      });
    }

  }
  // upload file to s3 location  for summary report(quantitative and qualitative) and split report
  uploadZipFile(filetype:string) {
    console.log(this.statevaluechange);
    console.log(this.filetype)
      /*
      @modifyed by Ravi G
      @date 26-09-2022
      @desc upload qualitative and quantitative and spliteReport file on s3 location
       */
      if(filetype ==='qualitative') {
        if ((this.statevaluechange.fileData === null || this.statevaluechange.fileData === undefined || this.statevaluechange.fileData === '')) {

          this.snackBar.open(this.constants.noCsvFileSelected, 'OK', {
            duration: 5000
          });

        }
        else {
          this.insertCsvToS3()

        }
      }
      else if (this.filetype==='quantitative') {
        if ((this.statevaluechange.quantitativeFileData === null || this.statevaluechange.quantitativeFileData === undefined || this.statevaluechange.quantitativeFileData === '')) {

          this.snackBar.open(this.constants.noCsvFileSelected, 'OK', {
            duration: 5000
          });
        }else {
          this.insertCsvToS3()

        }

      }
    else {

      this.snackBar.open(this.constants.noCsvFileSelected, 'OK', {
        duration: 5000
      });
    }

  }
  insertCsvToS3(){
    this.spinner.start();
    this.service.insertCsvToS3(this.statevaluechange).subscribe(res => {
      if (res.error == true) {
        this.snackBar.open(res.statusMessage, 'OK', {
          duration: 5000
        });
        this.spinner.stop();
      } else {
        this.snackBar.open(res.statusMessage, 'OK', {
          duration: 5000
        });
        /*
        @modified by Ravi G
        @date 26-09-2022
        @desc check is qualitative and quantitative file is upoaded if not delete old one from s3 location
       */
        if (this.filetype === 'qualitative')
        {
          this.isFileUploded=true
        }else{
          this.isQuantitativeFileUploaded=true
        }
        this.spinner.stop();
      }

    });

  }

  uploadCsvForSplitReport(reportType) {

  }

  closeFunction() {
    this.dialogref.close();
  }

  downloadTemplate() {
			  /*
        @modified by Aman Singh
        @date 16-05-2024
        @desc the file name from "CasesForSplitReports.csv" to "ReferenceKeysForSplitReport.csv" and column "CASE NUMBER" to "SOURCE_REFERENCE_KEY"
       */

    console.log('working');
    var data = [{
      'SOURCE_REFERENCE_KEY': '',
      'SETNO': ''
    }];
    this.JSONToCSVConvertor(data, 'ReferenceKeysForSplitReport', true);
  }

  JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

    var CSV = '';

    //This condition will generate the Label/Header
    if (ShowLabel) {
      var row = '';

      //This loop will extract the label from 1st index of on array
      for (var index in arrData[0]) {

        //Now convert each value to string and comma-seprated
        row += index + ',';
      }

      row = row.slice(0, -1);

      //append Label row with line break
      CSV += row + '\r\n';
    }

    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
      var row = '';

      //2nd loop will extract each column and convert it in string comma-seprated
      for (var index in arrData[i]) {
        row += '"' + arrData[i][index] + '",';
      }
      //add a line break after each row
      CSV += row + '\r\n';
    }

    if (CSV == '') {
      alert('Invalid data');
      return;
    }

    //Generate a file name
    var fileName = '';
    //this will remove the blank-spaces from the title and replace it with an underscore
    fileName += ReportTitle.replace(/ /g, '_');

    //Initialize file format you want csv or xls
    var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

    // Now the little tricky part.
    // you can use either>> window.open(uri);
    // but this will not work in some browsers
    // or you will not get the correct file extension

    //this trick will generate a temp <a /> tag
    var link = document.createElement('a');
    link.href = uri;

    //set the visibility hidden so it will not effect on your web-layout
    // @ts-ignore
    link.style = 'visibility:hidden';
    link.download = fileName + '.csv';

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  processFile() {
    //if action equals to 1 trigger emr to summary report else split report
    if (this.statevaluechange.action == 1) {
      this.generateSummaryReport();
    } else {
      if (this.isFileUploded) {
        this.generateSplitReport();

      } else {
        this.snackBar.open(this.constants.pleaseUploadCsvFile, 'OK', {
          duration: 5000
        });

      }
    }
  }

  generateSplitReport() {
    if (confirm('Are you sure you want to generate validation split report?')) {
      this.spinner.start();
      this.service.generateSplitReport(this.statevaluechange.migrationId).subscribe(res => {
        if (res.error == true) {
          this.snackBar.open(res.statusMessage, 'OK', {
            duration: 5000
          });
          this.spinner.stop();
        } else {
          this.snackBar.open(res.statusMessage, 'OK', {
            duration: 5000
          });
          this.closeFunction();
          this.spinner.stop();
        }

      });
    }

  }

  generateSummaryReport() {
    if (confirm('Are you sure you want to generate validation summary report?')) {
      this.spinner.start();
      this.service.generateSummaryReport(this.isFileUploded,this.isQuantitativeFileUploaded,this.statevaluechange.migrationId).subscribe(res => {
        console.log(res);
        if (res.error === true) {
          this.snackBar.open(res.data, 'OK', {duration: 5000});
          this.spinner.stop();
        } else {
          this.snackBar.open(res.data, 'OK', {duration: 5000});
          this.spinner.stop();
          this.closeFunction();
          //  this.retrieveMigrationLog();
        }
      });
    }
  }
}
